import type { ErrorInfo } from 'react';
import { Logger } from '../../utils/logger';

export const ERROR_BOUNDARY_PREFIX = 'PMS_APP';

export const errorLogger = (error: Error, info?: ErrorInfo) => {
  const logger = new Logger(ERROR_BOUNDARY_PREFIX);
  logger.error(error, info);
};
